import { ApiResponse } from 'apisauce';
import { IPaginationSnapshot } from 'src/models/pagination/Pagination';
import { IResponseSnapshot } from 'src/models/response/Response';

import { IPartner, IPartnerFilter, IPartnerSnapshot } from '../../models';
import { Api } from '../api/api';
import { getGeneralApiProblem } from '../api/api-problem';

import {
  TDeletePartnerResult,
  TGetPartnerResult,
  TGetPartnersResult,
  TPostPartnerResult,
  TUpdatePartnerResult,
} from './PartnerTypes';

/**
 * # Partner Api 서비스
 *
 * 서비스의 설명을 작성하세요.
 *
 * ## 사용방법
 *
 * ```ts
 * const service = new PartnerApi();
 *
 * ```
 */
export class PartnerApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async gets(paging: IPaginationSnapshot, params?: IPartnerFilter): Promise<TGetPartnersResult> {
    try {
      const url = `/v1/partner?page=${paging.page}&size=${paging.size}`;
      // const params = {};
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const partners: IPartner[] = response.data.data;
      const pagination: IPaginationSnapshot = response.data.pagination;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', partners, pagination, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  async get(id: number): Promise<TGetPartnerResult> {
    try {
      const url = `/v1/partner/${id}`;
      const params = {};
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const partner: IPartner = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', partner, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async post(partnerData: IPartnerSnapshot): Promise<TPostPartnerResult> {
    try {
      const url = '/v1/partner';
      const payload = partnerData;
      const response: ApiResponse<any> = await this.api.apisauce.post(url, payload);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const partner: IPartner = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', partner, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async update(partnerSid: number, partnerData: IPartnerSnapshot): Promise<TUpdatePartnerResult> {
    try {
      const url = `/v1/partner/${partnerSid}`;
      const payload = partnerData;
      const response: ApiResponse<any> = await this.api.apisauce.put(url, payload);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const partner: IPartner = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', partner, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async delete(id: number): Promise<TDeletePartnerResult> {
    try {
      const url = `/v1/partner/${id}`;
      const payload = {};
      const response: ApiResponse<any> = await this.api.apisauce.delete(url, payload);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  // async post(): Promise<TPostPartnerResult> {
  //   try {
  //     const url = '/partner';
  //     const payload = {};
  //     const response: ApiResponse<any> = await this.api.apisauce.post(url, payload);

  //     if (!response.ok) {
  //       const problem = getGeneralApiProblem(response);
  //       if (problem) return problem;
  //     }

  //     const partner: IPartner = response.data.results;
  //     return { kind: 'ok', partner };
  //   } catch (e) {
  //     return { kind: 'bad-data' };
  //   }
  // }

  // async update(id: number): Promise<TUpdatePartnerResult> {
  //   try {
  //     const url = `/partner/${id}`;
  //     const payload = {};
  //     const response: ApiResponse<any> = await this.api.apisauce.put(url, payload);

  //     if (!response.ok) {
  //       const problem = getGeneralApiProblem(response);
  //       if (problem) return problem;
  //     }

  //     const partner: IPartner = response.data.results;
  //     return { kind: 'ok', partner };
  //   } catch (e) {
  //     return { kind: 'bad-data' };
  //   }
  // }

  // async delete(id: number): Promise<TDeletePartnerResult> {
  //   try {
  //     const url = `/partner/${id}`;
  //     const payload = {};
  //     const response: ApiResponse<any> = await this.api.apisauce.delete(url, payload);

  //     if (!response.ok) {
  //       const problem = getGeneralApiProblem(response);
  //       if (problem) return problem;
  //     }

  //     return { kind: 'ok' };
  //   } catch (e) {
  //     return { kind: 'bad-data' };
  //   }
  // }
}
